import { useSmoothScroller } from '@/context/SmoothScrollerContext';
import { cn } from '@/lib/utils';
import { PathEnum } from '@/types/enums';
import { useTranslations } from 'next-intl';
import Link from '../ui/Link';
import Logotype from '../ui/Logotype';
import MenuMoreSection from './MenuMoreSection';
import MobileHeaderMenu from './MobileHeaderMenu';

export default function Header({ color }: { color: 'white' | 'black' }) {
    const t = useTranslations();
    // @ts-ignore
    const { lenis } = useSmoothScroller();

    const isBlack = color === 'black';

    const linkStyles = cn(
        'lowercase max-lg:text-[34px] lg:text-[26px] font-light font-helveticaNeue leading-none [&>span]:transition-none [&>span]:bg-none hover:[&>span]:italic',
        isBlack ? 'text-black' : 'text-tofu',
    );

    return (
        <header className="flex justify-between max-lg:px-5 z-10 fixed top-0 left-0 right-0 pt-8 max-lg:pt-4 px-10">
            <Link
                className="relative lg:w-[136px] lg:h-[132px] w-[106px] h-[102px] -translate-y-2"
                href={PathEnum.Home}
            >
                <Logotype color={color} />
            </Link>

            <div className="items-center mx-auto h-fit xl:gap-6 gap-2 lg:flex hidden">
                <Link
                    href={PathEnum.About}
                    className={linkStyles}
                    title={t('Header.about')}
                    onClick={() => {
                        lenis?.scrollTo('#about');
                    }}
                />
                <Separator />
                <Link
                    href={PathEnum.Watch}
                    className={linkStyles}
                    title={t('Header.watch')}
                    onClick={() => {
                        lenis?.scrollTo('#watch');
                    }}
                />
                <Separator />
                <Link
                    href={PathEnum.Discover}
                    className={linkStyles}
                    title={t('Header.discover')}
                    onClick={() => {
                        lenis?.scrollTo('#discover');
                    }}
                />
                <Separator />
                <Link
                    href={PathEnum.YourStory}
                    className={linkStyles}
                    title={t('Header.yourStory')}
                    onClick={() => {
                        lenis?.scrollTo('#your-story');
                    }}
                />
                <Separator />
                <Link
                    href={PathEnum.GetInvolved}
                    className={linkStyles}
                    title={t('Header.getInvolved')}
                />
            </div>

            <div className="flex-col items-end gap-3 lg:gap-6 hidden lg:flex">
                <MenuMoreSection color={color} />
            </div>

            <MobileHeaderMenu className="lg:hidden" color={color} />
        </header>
    );
}

const Separator = () => <div className="h-3 w-[1px] bg-blue-100" />;
